<template>
  <div class="car-list-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="custom-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>车辆列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主卡片 -->
    <el-card class="modern-card" shadow="never">
      <!-- 搜索栏 - 优化布局，整齐排列 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" ref="searchForRef" size="medium" class="search-form">
          <el-form-item label="标题">
            <el-input v-model="searchForm.title" placeholder="请输入标题" clearable prefix-icon="el-icon-search"></el-input>
          </el-form-item>
          <el-form-item label="车系">
            <el-cascader
              v-model="searchForm.style_ids"
              :props="{ value: 'id', label: 'name', children: 'children', checkStrictly: true }"
              :options="carStyleMenus"
              clearable
              placeholder="请选择车系"
              style="width: 220px"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="年份">
            <el-select
              v-model="searchForm.year_id"
              filterable
              clearable
              placeholder="请选择年份"
              style="width: 140px"
            >
              <el-option
                v-for="item in carYearList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="medium" @click="searchSubmit()" class="search-btn">搜索</el-button>
            <el-button type="primary" size="medium" @click="goAdd()" class="add-btn">
              <i class="el-icon-plus"></i> 新增加车辆
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        height="450"
        stripe
        border
        size="medium"
        class="modern-table"
        :header-cell-style="headerCellStyle"
        :row-style="{ height: '56px' }"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="车牌号" width="120" prop="car_number" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="car-number">{{ scope.row.car_number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标题" width="150" prop="title" show-overflow-tooltip></el-table-column>
        <el-table-column label="车系" width="220" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="car-style">
              {{ scope.row.style && scope.row.style.parent ? scope.row.style.parent.name : '' }}
              {{ scope.row.style ? scope.row.style.name : '' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="年份" width="120">
          <template slot-scope="scope">
            <el-tag size="small" effect="light">{{ scope.row.year ? scope.row.year.name : '--' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="孔距" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.pitch ? scope.row.pitch.name : '--' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="goEdit(scope.row)" class="action-link">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="modern-pagination"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 轮毂列表抽屉 -->
    <el-drawer title="轮毂列表" :visible.sync="drawerHub" :with-header="true" size="60%" class="modern-drawer">
      <div class="drawer-content">
        <el-table
          ref="hubTable"
          :data="hubList"
          size="medium"
          stripe
          border
          class="modern-table"
          :header-cell-style="headerCellStyle"
        >
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column label="图片" width="100" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 56px; height: 56px; border-radius: 12px"
                :src="scope.row.goods_img"
                :preview-src-list="[scope.row.goods_img]"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="名称" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="product-name">{{ scope.row.goods_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="孔距" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.pitch ? scope.row.pitch.name : '--' }}
            </template>
          </el-table-column>
          <el-table-column label="市场价" width="120" align="right">
            <template slot-scope="scope">
              <span class="price">¥{{ scope.row.market_price }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrapper" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="pageNum1"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
            class="modern-pagination"
          ></el-pagination>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>

export default {
  name: "carList",
  data() {
    return {
      carStyleMenus: [],
      pitch_id: '',
      drawerHub: false,
      hubList: [],
      total1: 0,
      pageNum1: 1,
      pageSize1: 20,
      searchForm: {
        title: "",
        style_ids: [],
        style_id: '',
        year_id: ''
      },
      carYearList: [],
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
    }
  },
  created() {
    this.DataList()
    this.getCarStyleMenus()
    this.getCarYeaList()
  },
  methods: {
    headerCellStyle() {
      return {
        backgroundColor: '#F8F9FC',
        color: '#1E2A3A',
        fontWeight: 600,
        fontSize: '14px',
        borderBottom: '1px solid #EDEFF2'
      }
    },
    getCarStyleMenus() {
      this.$axios.findCarStyleTree({
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }).then(res => {
        if (res.code == 200) this.carStyleMenus = res.data
      })
    },
    getCarYeaList() {
      this.$axios.findCarYearList({
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id')
      }).then(res => {
        if (res.code == 200) this.carYearList = res.data
      })
    },
    getval() {
      const obj = this.$refs['cascaderCarStyle']?.getCheckedNodes() || []
      this.searchForm.style_id = obj.length ? obj[0].data.id : ""
    },
    relationHub(row) {
      this.drawerHub = true
      this.pitch_id = row.pitch_id
      this.getHubList()
    },
    getHubList() {
      this.$axios.findHubListP({
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        pitch_id: this.pitch_id
      }).then(res => {
        if (res.code == 200) {
          this.hubList = res.data.data
          this.total1 = res.data.total
        }
      })
    },
    goEdit(row) {
      this.$router.push({ path: '/carForm', query: { id: row.id } })
    },
    goAdd() {
      this.$router.push('/carForm')
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    DataList() {
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        shop_id: sessionStorage.getItem('shop_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      if (this.searchForm.title) param.keyword = this.searchForm.title
      if (this.searchForm.style_id) param.style_id = this.searchForm.style_id
      if (this.searchForm.year_id) param.year_id = this.searchForm.year_id
      this.$axios.findCarListP(param).then(res => {
        if (res.code == 200) {
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }
      })
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    handleSizeChange1(newSize) {
      this.pageSize1 = newSize
      this.getHubList()
    },
    handleCurrentChange1(newPage) {
      this.pageNum1 = newPage
      this.getHubList()
    },
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    }
  }
}
</script>

<style scoped>
/* 整体容器背景 */
.car-list-container {
  background-color: #F5F7FA;
  min-height: 100vh;
  padding: 20px 24px 40px;
}

/* 面包屑 */
.custom-breadcrumb {
  margin-bottom: 20px;
}
.custom-breadcrumb >>> .el-breadcrumb__inner {
  color: #6C7A8E;
  font-weight: normal;
}
.custom-breadcrumb >>> .el-breadcrumb__inner a:hover {
  color: #1677FF;
}
.custom-breadcrumb >>> .el-breadcrumb__separator {
  color: #C0C4CC;
}

/* 主卡片 */
.modern-card {
  border-radius: 24px;
  border: none;
  background-color: #FFFFFF;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.01);
}
.modern-card >>> .el-card__body {
  padding: 24px 28px 32px;
}

/* 搜索栏 - 干净整齐的flex布局 */
.search-bar {
  background: #F8F9FC;
  padding: 18px 20px;
  border-radius: 20px;
  margin-bottom: 28px;
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}
.search-form >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 0;
}
.search-form >>> .el-form-item__label {
  font-weight: 500;
  color: #5A6878;
  padding-right: 8px;
}
.search-form >>> .el-input__inner,
.search-form >>> .el-select .el-input__inner,
.search-form >>> .el-cascader__label {
  border-radius: 40px;
  border: 1px solid #E4E7ED;
  height: 40px;
  line-height: 40px;
  transition: all 0.2s;
}
.search-form >>> .el-input__inner:focus,
.search-form >>> .el-select .el-input__inner:focus,
.search-form >>> .el-cascader__label:focus {
  border-color: #1677FF;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}
.search-btn,
.add-btn {
  border-radius: 40px;
  padding: 9px 24px;
  font-weight: 500;
  transition: transform 0.1s, box-shadow 0.2s;
}
.search-btn {
  background-color: #1AB86A;
  border-color: #1AB86A;
}
.search-btn:hover {
  background-color: #0F9A56;
  border-color: #0F9A56;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(26, 184, 106, 0.3);
}
.add-btn {
  background-color: #1677FF;
  border-color: #1677FF;
}
.add-btn:hover {
  background-color: #0958D9;
  border-color: #0958D9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3);
}

/* 表格 */
.modern-table {
  border-radius: 20px;
  overflow: hidden;
}
.modern-table >>> .el-table__header-wrapper th {
  background-color: #F8F9FC !important;
  font-weight: 600;
  color: #1E2A3A;
  border-bottom: 1px solid #EDEFF2;
}
.modern-table >>> .el-table__row td {
  border-bottom: 1px solid #F0F2F5;
}
.modern-table >>> .el-table__row:hover td {
  background-color: #FAFBFF !important;
}
.car-number {
  font-weight: 600;
  color: #1677FF;
  font-family: monospace;
}
.car-style {
  color: #2C3E50;
}
.action-link {
  color: #1677FF;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 30px;
}
.action-link:hover {
  background-color: #F0F7FF;
  color: #0958D9;
}

/* 分页 */
.pagination-wrapper {
  margin-top: 28px;
  display: flex;
  justify-content: flex-end;
}
.modern-pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1677FF;
  border-radius: 12px;
}
.modern-pagination >>> .el-pagination.is-background .el-pager li {
  border-radius: 12px;
  margin: 0 4px;
  font-weight: 500;
}
.modern-pagination >>> .el-pagination .btn-prev,
.modern-pagination >>> .el-pagination .btn-next {
  border-radius: 12px;
}

/* 抽屉 */
.modern-drawer >>> .el-drawer__header {
  background: linear-gradient(135deg, #F8F9FC 0%, #FFFFFF 100%);
  padding: 18px 24px;
  border-bottom: 1px solid #EDEFF2;
}
.modern-drawer >>> .el-drawer__header span {
  font-weight: 600;
  font-size: 18px;
  color: #1E2A3A;
}
.modern-drawer >>> .el-drawer__body {
  padding: 20px 24px;
  background-color: #F5F7FA;
}
.drawer-content {
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 4px;
}
.product-name {
  font-weight: 500;
  color: #1E2A3A;
}
.price {
  color: #FF6B6B;
  font-weight: 600;
}
</style>